import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LanguageService } from '../services/language/language.service';
import { ManageAccountService } from '../services/api-lab4u/user-auth/manage-account.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
declare function init_plugins(): void;
@Component({
  selector: 'app-complete-delete-account',
  templateUrl: './complete-delete-account.component.html',
  styleUrls: ['./complete-delete-account.component.css'],
  imports: [TranslocoDirective, RouterLink, MatProgressSpinner],
})
export class CompleteDeleteAccountComponent implements OnInit {
  language!: string;
  requestConfirmed = false;
  errorCode = 0;
  loading = true;
  payload = '';

  constructor(
    private route: ActivatedRoute,
    private manageAccountService: ManageAccountService,
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnInit() {
    init_plugins();
    this.payload = this.route.snapshot.queryParamMap.get('payload') || '';
    this.language = this.languageService.getLanguage();

    this.completeDeleteAccount();
  }

  completeDeleteAccount() {
    this.manageAccountService
      .accountDataDeletionComplete(this.payload)
      .subscribe({
        next: (data) => {
          this.requestConfirmed = true;
          this.loading = false;
          this.cdr.markForCheck();
        },
        error: (error) => {
          this.errorCode = error.status;
          this.requestConfirmed = false;
          this.loading = false;
          this.cdr.markForCheck();
        },
      });
  }
  /**
   * Function to change language localStorage
   * @param language Variable to save the actual language
   */
  changeLanguage(language: string) {
    if (language === 'es' || language === 'en') {
      this.language = language;
      this.languageService.applyLanguage(this.language);
      window.location.reload();
    } else {
      return;
    }
  }
}
